import { PlaybackGuard } from '@app/core/playback/context/PlaybackGuard';
import { DateTimeStr } from '@mi-front/core';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useFragment } from '../../hooks/useFragment';
import { FragmentGoToStreamFromPlaybackAction } from './actions/FragmentGoToStreamFromPlaybackAction';
import { FragmentGoToStreamFromStartAction } from './actions/FragmentGoToStreamFromStartAction';
import { FragmentGoToStreamWithSelectionAction } from './actions/FragmentGoToStreamWithSelectionAction';

const openInLoggerMessage = defineMessage({
  id: 'fragments.view.metadata.openInLogger',
  defaultMessage: 'Abrir en Logger:',
});

/**
 * Logger navigation actions grouped under the media player: open at start,
 * select fragment, and open at the current playhead. Hairline below separates them from description.
 */
export function FragmentMediaLoggerActions() {
  const { fragment, station } = useFragment();
  const hasDescription = !!fragment.description?.trim();

  return (
    <PlaybackGuard>
      <Box sx={{ mt: 1.5 }}>
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage {...openInLoggerMessage} />
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
            <FragmentGoToStreamFromStartAction
              stationSlug={station.slug}
              fragmentFrom={fragment.from as DateTimeStr}
            />
            <FragmentGoToStreamWithSelectionAction
              stationSlug={station.slug}
              fragmentFrom={fragment.from as DateTimeStr}
              fragmentTo={fragment.to as DateTimeStr}
            />
            <FragmentGoToStreamFromPlaybackAction stationSlug={station.slug} />
          </Stack>
        </Stack>
        {hasDescription && <Divider sx={{ borderBottomWidth: '0.5px', mt: 1.5 }} />}
      </Box>
    </PlaybackGuard>
  );
}
